import {createRouter, createWebHistory} from 'vue-router'
import {userAuthenticate} from "@/functions/userAuthenticate";

const routes = [
    {
        path: '/',
        redirect: '/landing',
    },
    {
        path: '/landing',
        name: 'LandingPage',
        component: () => import("@/views/pages/LandingPage.vue"),
    },
    {
        path: '/confirm',
        name: 'ConfirmPage',
        component: () => import("@/views/pages/ConfirmPage.vue"),
    },
    {
        path: '/insufficient-funds',
        name: 'InsufficientFunds',
        component: () => import("@/views/pages/InsufficientFunds.vue"),
    },
    {
        path: '/prompt',
        name: 'PromptPage',
        component: () => import("@/views/pages/PromptPage.vue"),
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0);
    }
})

router.beforeEach(async (to, from, next) => {
    await userAuthenticate(to, from, next);
})

export default router
